<template>
  <div>
    <PopoverRight ref="popoverMenu" width="650px">
      <div class="popover-slider-bar">
        <h1 class="bar-title">生成动态</h1>
        <el-form class="form-container" :model="createInfo" :rules="createRules" ref="createInfo">
          <div class="form-item">
            <div class="form-label" style="text-align: center;">
              <span class="label">生成方式</span>
            </div>
            <div class="form-input-item">
              <el-form-item label prop="">
                <el-radio v-model="creatType" :label="1">指定站点</el-radio>
                <el-radio v-model="creatType" :label="2">指定楼盘</el-radio>
              </el-form-item>
            </div>
          </div>
          <template v-if="creatType == 1">
            <div class="form-item site-sp">
              <div class="site-label">
                <span class="label">站点列表：</span>
                <label class="warn">*</label>
                <label class="ipt"><input type="checkbox" class="checkbox" @click="selectAll"
                    :checked="checkAll" />全选</label>
                <label class="ipt"><input type="checkbox" class="checkbox" @click="selectStatus"
                    :checked="checkOwn" />未代理站点</label>
              </div>
              <br />
              <div class="form-input-site">
                <div v-if="this.siteList.length > 0">
                  <label v-for="(item, key) in siteList" :key="key">
                    <input :id="key" type="checkbox" :value="item.id" v-model="checkedSite" />{{ item.name }}
                  </label>
                </div>
                <div v-else>暂无数据</div>
              </div>
            </div>
            <div class="form-item">
              <div class="form-label">
                <span class="label">楼盘销售状态</span>
                <label class="warn">*</label>
              </div>
              <div class="form-input-item">
                <el-form-item label prop="sale_info">
                  <el-select v-model="createInfo.sale_info" placeholder="请选择">
                    <el-option v-for="item in saleStateList" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
            </div>
            <div class="form-item">
              <div class="form-label">
                <span class="label">动态最近更新状态</span>
                <label class="warn">*</label>
              </div>
              <div class="form-input-item">
                <el-form-item label prop="update_status">
                  <el-select v-model="createInfo.update_status" placeholder="请选择">
                    <el-option v-for="item in updataStateList" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
            </div>
            <div class="form-item">
              <div class="form-label">
                <span class="label">每个站点预选楼盘数</span>
                <span class="hint">（不足时按实际量生成)</span>
                <label class="warn">*</label>
              </div>
              <div class="form-input-item">
                <el-form-item label prop="create_num">
                  <el-input placeholder="可输入1-100以内的数字" v-model="createInfo.create_num"></el-input>
                </el-form-item>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="form-item" style="height: 152px">
              <div class="form-label">
                <span class="label">选择文件</span>
                <label class="warn">*</label>
              </div>
              <div class="form-input-item">
                <el-form-item prop="path">
                  <div class="dongtai-input">
                    <div class="upload-group clearfix" v-if="file && file !== ''">
                      <div class="upload-item">
                        <img :src="excelUrl" alt />
                        <div class="shadow">
                          <i class="el-icon-delete" @click="clearUploadDt"></i>
                        </div>
                      </div>
                    </div>
                    <div class="upload-group-2" v-else>
                      <i class="el-icon-plus"></i>
                      <input type="file" class="type-file" accept="xlsx" @change="checkDtFile($event)"
                        id="pictureUploadZt" />
                    </div>
                    <p class="download">下载<a :href="modelDownload">导入模板</a></p>
                  </div>
                </el-form-item>
              </div>
            </div>
          </template>
          <div class="form-button">
            <el-button type="primary" :loading="isLoading" @click="submitForm('createInfo', 1)" v-preventReClick='7000'>生成至草稿箱</el-button>
            <el-button type="primary" :loading="isLoading" @click="submitForm('createInfo', 2)" v-permission="'operating.house-trend-model-manage.trend-list.push'" v-preventReClick='7000'>生成并发布</el-button>
            <el-button type="info" plain @click.stop.prevent="hide">取 消</el-button>
          </div>
        </el-form>
        <!--echarts区域-->
        <!-- <div id="siteEchartArea"></div> -->
        <!--echarts进度条-->
        <!-- <div class="progressDia" v-if="showProgress">
          <div class="cover"></div>
          <div class="content">
            <h2>走势图生成进度 <i class="el-icon-close"></i></h2>
            <el-progress :percentage="percentage"></el-progress>
            <span>已生成：{{ focusNum }}/{{ siteNum }}</span>
          </div>

        </div> -->


      </div>
    </PopoverRight>

  </div>

</template>
  
<script>
import PopoverRight from "@/components/popoverRight/index";
import { validateNumber } from "@/utils/validate";
//   import {newsCreate ,getPriceData,creatPriceData,comparePriceData} from "@/service/newsModel";
import { getSite } from "@/service/site";
import {dynamiCreateBySite,dynamiCreateByHouse} from '@/service/dynamicModel'
export default {
  name: "add",
  components: {
    PopoverRight,
  },
  props: {
    callback: Function,
  },
  data() {

    return {
      creatType: 1,
      isLoading:false,
      excelUrl:'',
      file:null,
      createInfo: {
        is_drafts:"",
        template_id:"",
        create_num:"",
        sale_info:"0",
        site_ids:"",
        update_status:"1"
      },
      saleStateList: [{
        name: "不限",
        id: "0",
      }, {
        name: "在售",
        id: "1",
      }, {
        name: "待售",
        id: "2",
      }, {
        name: "售完",
        id: "3",
      }, {
        name: "尾盘",
        id: "4",
      }],
      updataStateList: [{
        name: "不限",
        id: "1",
      }, {
        name: "7天未更新",
        id: "2",
      }, {
        name: "30天未更新",
        id: "3",
      }],
      checkAll: false,
      checkOwn: false,
      siteList: [],
      checkedSite: [],
      createRules: {
        create_num: [
          { validator: validateNumber,type:1,min:1,max: 100,result: "数量",trigger: "blur"},
        ],
      },
      submitType: null,//提交方式
      needCreatSite: [],//需要生成价格图片的站点
      siteLen: 0,//选中站点的数量
      chartData: [], //站点、区域价格数据
      chartImgData: { charts: [] },
      siteNum: 0,
      focusNum: 0,
      percentage: 0,
      showProgress: false,
      modelDownload:""
    };
  },
  watch: {
    checkedSite: function () {
      if (
        this.checkedSite.length == this.siteList.length &&
        this.checkedSite.length > 0
      ) {
        this.checkAll = true;
        this.checkOwn = false;
      } else {
        this.checkAll = false;
      }
    },
  },
  mounted(){
    const domain=document.domain;
    const host = window.serverConfig[window.siteMap[domain]].VUE_APP_FRIEND_LINK_URL;
    this.modelDownload = host+'楼盘动态指定楼盘模板.xls';
  },
  methods: {
    async open(id) {
      this.createInfo.template_id = id;
      this.$refs.popoverMenu && this.$refs.popoverMenu.open();
      this.$refs.createRules && this.$refs.createRules.clearValidate();
    },
    selectAll(event) {
      var _this = this;
      if (!event.currentTarget.checked) {
        this.checkedSite = [];
        this.checkOwn = false;
      } else {
        _this.checkedSite = [];
        _this.siteList.forEach(function (item) {
          _this.checkedSite.push(item.id);
        });
      }
    },
    selectStatus(event) {
      var _this = this;
      if (!event.currentTarget.checked) {
        _this.checkedSite = [];
        _this.checkOwn = false;
      } else {
        getSite({ agent_status: 1, per_page: 1000 }).then((data) => {
          let noStatus = data.data;
          _this.checkedSite = [];
          noStatus.forEach((el) => {
            _this.checkedSite.push(el.id);
          });
          _this.checkOwn = true;
        });
      }
    },
    hide() {
      this.resetForm();
      this.$refs.popoverMenu && this.$refs.popoverMenu.hide();
    },
    resetForm() {
      this.createInfo = {
        is_drafts:"",
        template_id:"",
        create_num:"",
        sale_info:"0",
        site_ids:"",
        update_status:"1"
      };
      this.excelUrl="",
      this.file=null,
      this.checkedSite = [];
      this.checkOwn = false;
    },

    submitForm(formName, type) {
      this.submitType = type
      if(this.creatType==1){
        if(this.checkedSite.length <= 0) {
          this.$message({
            type: "error",
            message: "请选择站点",
          });
          return;
        }
        this.$refs[formName].validate(async (valid) => {
          if (valid) {
              this.creatDynamicBySite();
          } else {
            return false;
          }
        });
      }else{
        if(!this.file) {
          this.$message({
            type: "error",
            message: "请选择文件",
          });
          return;
        }else{
          this.creatDynamicByHouse();
        }
      }

    },
    creatDynamicBySite() { // 按站点生成动态
      let query = this.createInfo;
      query.site_ids = this.checkedSite.join("_");
      query.type = this.creatType;
      query.is_drafts = this.submitType;
      this.isLoading = true;
      dynamiCreateBySite(query)
        .then((data) => {
          this.$message({
            message: "生成动态成功",
            type: "success",
            duration: 3 * 1000,
          });
          this.isLoading = false;
          this.hide();
          this.callback && this.callback();
        })
        .catch((err) => {
          this.$message({
            message: err.message || "添加失败",
            type: "error",
            duration: 3 * 1000,
          });
          this.isLoading = false;
        });
    },
    creatDynamicByHouse() { // 按楼盘生成动态
      let query = {};
      const formData = new FormData();
      formData.append("file", this.file);
      formData.append("type", this.creatType);
      formData.append("template_id",  this.createInfo.template_id);
      formData.append("is_drafts",  this.submitType);
      this.isLoading = true;
      dynamiCreateByHouse(formData)
        .then((data) => {
          this.$message({
            message: "生成动态成功",
            type: "success",
            duration: 3 * 1000,
          });
          this.isLoading = false;
          this.hide();
          this.callback && this.callback();
        })
        .catch((err) => {
          this.$message({
            message: err.message || "添加失败",
            type: "error",
            duration: 3 * 1000,
          });
          this.isLoading = false;
        });
    },
    checkDtFile(e) {
        const file = e.target;
        const filePath = file.value;
        if (!filePath) return false;
        if (!/.(xls)$/.test(filePath)) {
            this.$message({
            type: "error",
            message: "请选择xls格式",
            });
            return false;
        }
        this.zipImg();
        this.file = file.files[0]
        
    },
    clearUploadDt() {
        this.$set(this, "file", "");
    },
    zipImg() {
        if (process.env.NODE_ENV === "development") {
            this.excelUrl = process.env.VUE_APP_RESOURCE_URL + "/image/excel.jpg";
        } else {
            this.excelUrl =
            window.serverConfig[window.siteMap[domain]].VUE_APP_RESOURCE_URL +
            "/image/excel.jpg";
        }
    },

  },
};
</script>
  
<style scoped lang="less" >
.upload-group-2 {
  position: relative;
  width: 150px;
  height: 150px;
  border: 1px dashed #dcdfe6;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  .el-icon-plus {
    font-size: 30px;
    color: #999;
  }
  .type-file {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
  }
  input{
      height: 152px !important;;
  }
}
.upload-group {
  .upload-item {
    width: 150px;
    height: 150px;
    position: relative;
    float: left;
    img {
      width: 100%;
      height: 100%;
      display: block;
      object-fit: cover;
    }
    .shadow {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.5);
      display: -webkit-box;
      -webkit-box-align: center;
      -webkit-box-pack: center;
      cursor: pointer;
      transition: all 0.1s linear;
      opacity: 0;
      .el-icon-delete {
        font-size: 21px;
        color: #fff;
        display: block;
      }
    }
    &:hover {
      .shadow {
        opacity: 1;
      }
    }
    .el-icon-close {
      position: absolute;
    }
  }
}
.popover-slider-bar .form-container .form-item .form-label {
  width: 28% !important;
}

.popover-slider-bar .form-container .form-item .form-input-item {
  width: 72% !important;
}
.popover-slider-bar .form-container .form-item .form-input-item .download{
    display: inline-block;
    position: absolute;
    left: 170px;
    bottom: 0;
}
.popover-slider-bar .form-container .form-item .form-input-item .download a{
  text-decoration: none;
  color:#409EFF
}
.site-sp {
  display: block !important;
  padding-left: 30px;
}

.site-label {
  width: 100%;
  height: 30px;
}

.site-label .ipt {
  margin-right: 20px;
}

.form-input-site {
  min-height: 100px;
  width: 100%;
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid #ddd;
  padding: 20px;
  box-sizing: border-box;
}

.form-input-site label {
  margin-right: 15px;
  padding-bottom: 10px;
  display: inline-block;
}

.form-input-site label input {
  margin-right: 5px;
}

.popover-slider-bar .form-container .form-item .form-label {
  width: 25% !important;
  position: relative;

}

.popover-slider-bar .form-container .form-item .hint {
  position: absolute;
  left: 0;
  top: 27px;
}

.topic-loading.el-loading-parent--relative {
  position: initial !important;
}

.topic-loading {
  z-index: 9999 !important;
}

.topic-loading /deep/ .el-loading-mask {
  position: fixed;
  top: 0px;
  left: 200px !important;
}

#siteEchartArea {
  width: 520px;
  height: 350px;
  display: none;

}

canvas {
  width: 520px;
  height: 350px;
}

.progressDia {
  border-radius: 2px 0 0 2px;
  height: 100VH;
  box-sizing: border-box;
  margin-top: 0px;
  width: 650px;
  position: absolute;
  top: 0;
  left: 0;
}

.progressDia .cover {
  background: #000;
  margin-top: 0px;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  opacity: .5;
}

.progressDia .content {
  padding: 20px;
  width: 60%;
  height: 130px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
}

.progressDia .content h2 {
  font-size: 20px;
  font-weight: bold;
  line-height: 20px;
  margin-bottom: 30px;
}

.progressDia .content span {
  font-size: 16px;
}

.progressDia .el-progress {
  margin-bottom: 10px;
}
</style>
  